import { useEffect, useRef, } from "react";
import { useApp } from "../../hooks/AppProvider";

function Log1(props) {
    let app = useApp();
    let passwordInputRef = useRef(null);

    useEffect(() => {
        if(passwordInputRef.current) {
            passwordInputRef.current.focus();
        }

        if(!app.emptyCheck(props.password))
            connect();
    }, []);

    function changePassword(e) {
        props.setPassword(e.target.value);
    }

    function changeUsername(e) {
        props.setUsername(e.target.value);
        props.setState(0);
    }

    function connect() {        
        if(app.emptyCheck(props.username) || app.emptyCheck(props.password)) {
            return props.setStatusMessage("Nom d'utilisateur ou mot de passe vide");
        }

        app.sendPost("/auth/login/1", {username: props.username, password: props.password}, data => {
            switch(data.next) {
                case -1:
                    app.setTokens(data.access_token, data.refresh_token);
                    break;
                case 1:
                    props.setStatusMessage("Mot de passe incorrect")
                    passwordInputRef.current.select();
                    passwordInputRef.current.focus();
                    break;
            }
            
            props.setState(data.next);
        });
    }

    function handleConnect(e) {
        if(e.key === "Enter") {
            e.preventDefault();
            connect();
        }
    }

    return (
        <>
            <span className="login-label">Nom d'utilisateur</span>
            <input value={props.username} onChange={changeUsername} placeholder="Nom d'utilisateur"></input>
            <span className="login-label">Mot de passe</span>
            <input ref={passwordInputRef} type="password" value={props.password} onKeyDown={handleConnect} onChange={changePassword} placeholder="Mot de passe"></input>
            <button onClick={connect}>Se connecter</button>
        </>
    )
}

export default Log1;